import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox, message } from "antd";
import { useTranslation } from "react-i18next";
import VoiceInput from "./VoiceInput"; // adjust import

// interface NotesModalProps {
//   open: boolean;
//   onClose?: () => void;
//   onAdd?: (note: string, notifySupervisor: boolean) => void;
//   showNotifySupervisor?: boolean;
//   loading?: boolean;
//   maxLength?: number;
// }

const NotesModal = ({
  open,
  onClose,
  onAdd,
  showNotifySupervisor = false,
  loading = false,
  maxLength = 700,
}) => {
  const { t } = useTranslation();

  const [note, setNote] = useState("");
  const [notifySupervisor, setNotifySupervisor] = useState(false);

  useEffect(() => {
    if (open) {
      setNote("");
      setNotifySupervisor(false);
    }
  }, [open]);

  const handleAdd = () => {
    const trimmed = note.trim();

    if (trimmed.length < 8) {
      message.error(t("Note must be at least 8 characters long."));
      return;
    }

    onAdd?.(trimmed, notifySupervisor);

    setNote("");
    setNotifySupervisor(false);

    onClose?.();
  };

  const handleCopy = async () => {
    if (!note.trim()) return;

    await navigator.clipboard.writeText(note);

    message.success(t("Copied"));
  };

  return (
    <Modal
      title={t("Add Note To Schedules")}
      open={open}
      onCancel={onClose}
      // closable={false}
      maskClosable={false}
      keyboard={false}
      footer={[
        note.trim() && (
          <Button key="copy" onClick={handleCopy}>
            {t("Copy")}
          </Button>
        ),

        <Button
          key="add"
          type="primary"
          loading={loading}
          onClick={handleAdd}
        >
          {t("Add")}
        </Button>,
      ]}
    >
      <VoiceInput
        as="textarea"
        showCount
        maxLength={maxLength}
        value={note}
        placeholder={t("Enter your note here")}
        onChange={(e) => setNote(e.target.value)}
        style={{
          width: "100%",
          // minHeight: 170,
        }}
      />

      {showNotifySupervisor && (
        <div style={{ marginTop: 12 }}>
          <Checkbox
            checked={notifySupervisor}
            onChange={(e) => setNotifySupervisor(e.target.checked)}
          >
            {t("Notify Supervisor")}
          </Checkbox>
        </div>
      )}
    </Modal>
  );
};

export default NotesModal;